import { render } from "./DefaultPool.vue?vue&type=template&id=a60126fa&scoped=true&ts=true"
import script from "./DefaultPool.vue?vue&type=script&lang=ts"
export * from "./DefaultPool.vue?vue&type=script&lang=ts"

import "./DefaultPool.vue?vue&type=style&index=0&id=a60126fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60126fa"]])

export default __exports__